import { CampaignuiBaseColumn } from '@bingads-webui-campaign/campaignui-base-column';

export class ColumnDemographic extends CampaignuiBaseColumn {
  constructor({ i18n }) {
    const localizedTitle = i18n.getString('CampaignSettingsGrid_ColumnHeader_Demographics');

    super({
      name: 'Demographic',
      type: 'string',
      property: 'CampaignCriterions',
      sortable: false,
      title: 'CampaignSettingsGrid_ColumnHeader_Demographics',
      helpId: 'Page_CampaignGrids_Demographic',
      i18n,
      helpAriaLabel: i18n.getString('Click to learn more about {{item}}', { item: localizedTitle }),
    });

    this.i18n = i18n;
  }

  get property() {
    return {
      get: () => this.i18n.getString('Page_PFPCampaignOrder_AllDemogExcerpt'),
      key: this.config.property,
    };
  }
}
